import { appStore } from '@/store';
import { CI, features, logger } from '@/lib';
import { EVENTS, startLogPerformanceTime } from '@/lib/logger/cplUtils';

// If imported from ./graphql we get circular dependency
import { approvePayment, preAuthorizePaymentPlan } from './graphql/api';

const threeDSHandler = ({
  is3DSecureRequired,
  threeDS2ContingencyData,
  threeDS1ContingencyData,
}) => {
  logger.info('threeds_handler_called');
  // If 3DS is not required we are done and can approve
  // the payment and return the user to the merchant
  if (!is3DSecureRequired) {
    const isCPAEligible = features.config.CTAMessageTreatment !== 'CONTROL';

    if (isCPAEligible) {
      return preAuthorizePaymentPlan();
    }
    return approvePayment();
  }

  startLogPerformanceTime(EVENTS.THREE_DS_CONTINGENCY);
  if (!threeDS1ContingencyData) {
    logger.info('threeds_2_handler_called');
    threeDS2ContingencyHandler(threeDS2ContingencyData);
  }
};

const threeDS2ContingencyHandler = threeDS2ContingencyData => {
  CI.start(CI.Event.CONTINGENCY_RESOLVE_3DS_USER_INPUT);

  const { api: apiActions, ui: uiActions } = appStore.getActions();

  // TODO: ADD_CARD integration bug fix - missing 'r' in confirmation
  if (threeDS2ContingencyData.confimationMethod) {
    threeDS2ContingencyData.confirmationMethod =
      threeDS2ContingencyData.confimationMethod;
  }

  // If the contingency handling is after checkout session call
  // which can be determined based on confirmationMethod presence
  // in contingency object, we should populate amount and currency
  // of the transaction from fundingOption returned by createCheckoutSession
  if (!threeDS2ContingencyData.confirmationMethod) {
    const { api: apiState } = appStore.getState();
    const { amount = {} } = apiState.fundingSource || {};
    const { currencyCode, currencyValue } = amount;

    logger.info('three_ds_2_transaction_setting_amount_and_currency_code', {
      currencyCodePresent: Boolean(currencyCode),
      currencyValuePresent: Boolean(currencyValue),
    });

    threeDS2ContingencyData.currencyCode = currencyCode;
    threeDS2ContingencyData.currencyValue = currencyValue;
  }

  apiActions.setThreeDS2ContingencyData(threeDS2ContingencyData);
  uiActions.toggleIsFormSubmitting(false);
  uiActions.toggleIsThreeDS2Shown(true);
};

export { threeDSHandler };
